let coreBaseUrl = "http://localhost:5000";

export type CoreApiAuth = {
  useAccessToken: () => string | undefined;
  useHeaders: () => Record<string, string | undefined>;
};

let coreAuth: CoreApiAuth = {
  useAccessToken: () => undefined,
  useHeaders: () => ({}),
};

export const getCoreApiBaseUrl = () => coreBaseUrl;

export const setCoreApiBaseUrl = (url: string) => {
  coreBaseUrl = url;
};

export const setCoreApiAuth = (auth: CoreApiAuth) => {
  coreAuth = auth;
};

export const getCoreApiAuth = () => coreAuth;
